import React from "react"
import { Button, Col, Row } from "react-bootstrap"
import { useHistory } from "react-router-dom"
import { ResultRenderer, PendingModal, PendingModalProps, getStartPending } from "../../components/PendingModal"
import { ImportConversionRule } from "./ImportConversionRule"

const mockSaveConversionRule = (): Promise<boolean> => new Promise((resolve) => setTimeout(() => resolve(true), 1000))

const mockGenerateConversionRule = (): Promise<boolean> =>
  new Promise((resolve) => setTimeout(() => resolve(true), 1000))

export const ConversionRuleEditorFooter = (props: {}) => {
  const history = useHistory()
  const handleCancel = () => history.goBack()

  const [pendingModalProps, setPendingModalProps] = React.useState<PendingModalProps<boolean>>({
    pendingResult: "NotStarted",
    resultRenderer: SaveResultRenderer
  })

  const onClickSave = getStartPending(mockSaveConversionRule, setPendingModalProps, SaveResultRenderer)
  const onClickGenerate1to2 = getStartPending(mockGenerateConversionRule, setPendingModalProps, GenerateResultRenderer)
  const onClickGenerate2to1 = getStartPending(mockGenerateConversionRule, setPendingModalProps, GenerateResultRenderer)

  return (
    <>
      <PendingModal {...pendingModalProps} />
      <Row className="d-flex flex-fill justify-content-between py-2 align-items-center">
        <Col className="text-left pl-0">
          <ImportConversionRule>Import rule</ImportConversionRule>
        </Col>
        <Col className="text-center">
          <Button variant="secondary" size="sm" className="m-1" onClick={onClickGenerate1to2}>
            Generate Rule 1 <InlineIcon>arrow_right</InlineIcon> 2
          </Button>
          <Button variant="secondary" size="sm" className="m-1" onClick={onClickGenerate2to1}>
            Generate Rule 1 <InlineIcon>arrow_left</InlineIcon> 2
          </Button>
        </Col>
        <Col className="text-right pr-0">
          <Button size="sm" className="my-1" onClick={onClickSave}>
            Save mapping
          </Button>
          <Button variant="secondary" className="ml-2 my-1" size="sm" onClick={handleCancel}>
            Cancel
          </Button>
        </Col>
      </Row>
    </>
  )
}

const InlineIcon = (props: any) => (
  <span style={{ verticalAlign: "middle" }}>
    <i className="modus-icons" style={{ fontSize: "12px" }}>
      {...props.children}
    </i>
  </span>
)

const SaveResultRenderer: ResultRenderer<boolean> = {
  onPending: () => "Saving...",
  onSuccess: (data: boolean) => "Save successful!",
  onError: (error: unknown) => "Save failed!",
  showResultTimeMs: 1500
}

const GenerateResultRenderer: ResultRenderer<boolean> = {
  onPending: () => "Generating...",
  onSuccess: (data: boolean) => "Conversion rule successfully generated!",
  onError: (error: unknown) => "Failed to generate conversion rule",
  showResultTimeMs: 1500
}
